<section class="reg-page">
  <div class="reg-card">
    <h1>Create your account</h1>
    <p class="intro">Start with a verified customer account so you can continue to statements and reconciliation.</p>

    @if (!registrationResult) {
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <label>Email address</label>
        <input formControlName="email" type="email" placeholder="me@company.com" />
        @if (email.invalid && (email.dirty || email.touched)) {
          <div class="error">
            @if (email.errors?.['required']) { <small>Email is required.</small> }
            @if (email.errors?.['email']) { <small>Enter a valid email address.</small> }
          </div>
        }

        <label>Password</label>
        <input formControlName="password" type="password" placeholder="At least 10 characters" />
        @if (password.invalid && (password.dirty || password.touched)) {
          <div class="error">
            @if (password.errors?.['required']) { <small>Password is required.</small> }
            @if (password.errors?.['minlength']) { <small>Password must be at least 10 characters.</small> }
          </div>
        }

        <label>Confirm password</label>
        <input formControlName="confirmPassword" type="password" placeholder="Repeat your password" />
        @if ((confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) || passwordsDoNotMatch) {
          <div class="error">
            @if (confirmPassword.errors?.['required']) { <small>Please confirm your password.</small> }
            @if (passwordsDoNotMatch) { <small>Passwords do not match.</small> }
          </div>
        }

        <label class="checkbox-row">
          <input formControlName="termsAccepted" type="checkbox" />
          <span>I accept the terms and conditions.</span>
        </label>
        @if (termsAccepted.invalid && (termsAccepted.dirty || termsAccepted.touched)) {
          <div class="error"><small>You must accept the terms and conditions.</small></div>
        }

        <div class="actions">
          <button class="btn primary" type="submit" [disabled]="form.invalid || passwordsDoNotMatch || isSubmitting">
            {{ isSubmitting ? 'Creating account...' : 'Register' }}
          </button>
          <a class="btn ghost" routerLink="/login">Already have an account?</a>
        </div>
      </form>
    }

    @if (errorMessage) {
      <div class="message error-banner">{{ errorMessage }}</div>
    }

    @if (registrationResult) {
      <div class="message success-card">
        <h2>Registration successful</h2>
        <p>{{ registrationResult.message }}</p>
        <p><strong>Email:</strong> {{ registrationResult.email }}</p>
        <p><strong>Status:</strong> {{ registrationResult.status }}</p>

        @if (registrationResult.verificationPath) {
          <div class="verify-actions">
            <a class="btn primary" [routerLink]="['/verify', registrationResult.id, registrationResult.verificationCode]">
              Verify now in the app
            </a>
          </div>
        }

        @if (registrationResult.verificationCode) {
          <p class="helper-note">
            Temporary MVP helper: verification code <code>{{ registrationResult.verificationCode }}</code>
          </p>
        }
      </div>
    }
  </div>
</section>
